var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 49.555 c 8.754 0 15.851 -10.757 15.851 -19.511 v -4.662 H 29.149 v 4.662 C 29.149 38.798 36.246 49.555 45 49.555 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25.645 21.479 h 38.71 c 1.069 0 1.935 -0.867 1.935 -1.935 c 0 -1.069 -0.867 -1.935 -1.935 -1.935 h -2.1 c -0.587 -5.526 -3.616 -10.939 -7.958 -14.273 l -2.263 7.461 c -0.253 0.835 -1.022 1.374 -1.851 1.374 c -0.186 0 -0.375 -0.027 -0.562 -0.084 c -1.023 -0.31 -1.601 -1.391 -1.291 -2.414 l 2.44 -8.046 c 0.036 -0.117 0.084 -0.227 0.139 -0.332 C 49.064 0.467 47.075 0 45 0 c -2.074 0 -4.063 0.467 -5.907 1.294 c 0.055 0.105 0.103 0.215 0.139 0.332 l 2.44 8.046 c 0.31 1.023 -0.267 2.104 -1.29 2.414 c -0.187 0.057 -0.377 0.084 -0.562 0.084 c -0.831 0 -1.598 -0.539 -1.852 -1.374 l -2.263 -7.461 c -4.343 3.334 -7.371 8.747 -7.959 14.273 h -2.1 c -1.069 0 -1.935 0.867 -1.935 1.935 C 23.71 20.612 24.576 21.479 25.645 21.479 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62.773 55.854 c 0.082 -0.138 0.181 -0.257 0.289 -0.366 c -1.953 -1.754 -4.156 -3.236 -6.559 -4.367 c -3.294 3.023 -7.248 4.963 -11.503 4.963 s -8.208 -1.94 -11.503 -4.963 c -2.409 1.134 -4.616 2.62 -6.572 4.38 c 0.102 0.106 0.197 0.221 0.275 0.354 c 5.104 8.603 7.923 19.741 8.618 34.052 c 0.002 0.032 -0.005 0.062 -0.005 0.094 h 18.345 c 0 -0.032 -0.006 -0.062 -0.005 -0.094 C 54.85 75.595 57.669 64.457 62.773 55.854 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65.808 58.349 C 61.234 66.31 58.683 76.67 58.027 90 h 14.017 V 75.598 C 72.044 69.036 69.696 63.031 65.808 58.349 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.956 75.598 V 90 h 13.99 c -0.657 -13.318 -3.203 -23.672 -7.77 -31.631 C 20.298 63.048 17.956 69.046 17.956 75.598 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorker);
export default __webpack_public_path__ + "static/media/Worker.43929b4aac344d7416b2194dc76ac41e.svg";
export { ForwardRef as ReactComponent };